import { HngAppConfigInterface } from './app-config.interface';
import { HngLayoutSettingsInterface } from './layout-settings.interface';
import { InjectionToken } from '@angular/core';

const remP = 16;
function rP(rems: number): number {
  return rems * remP;
}

/**
 * App Configuration/Settings
 * Configuration settings used by various services.
 * This should be configured in your App Module, and passed as initializers for the services that need it.
 */
export class HngAppConfig implements HngAppConfigInterface {
  public readonly appCode: string;
  public readonly appName: string;
  public readonly apiUrl: string;
  public readonly userApiUrl: string;
  public readonly gaCode?: string;
  public readonly signInUrl?: string;
  public readonly signOutUrl?: string;
  public readonly layout: HngLayoutSettingsInterface = {
    remP: remP,
    breakpoints: {
      smP: rP(40),
      mdP: rP(48),
      lgP: rP(64),
      xlP: rP(80),
      xxlP: rP(96),
    },
  };

  constructor(config: Partial<HngAppConfigInterface>) {
    if (config.appCode) {
      this.appCode = config.appCode;
    } else {
      this.appCode = 'app-code';
    }
    if (config.appName) {
      this.appName = config.appName;
    } else {
      this.appName = 'Configure Me!';
    }
    if (config.apiUrl) {
      this.apiUrl = config.apiUrl;
    } else {
      this.apiUrl = 'https://api.app.com/';
    }
    if (config.userApiUrl) {
      this.userApiUrl = config.userApiUrl;
    } else {
      this.userApiUrl = 'https://app.com/';
    }
    if (config.gaCode) {
      this.gaCode = config.gaCode;
    }
    if (config.signInUrl) {
      this.signInUrl = config.signInUrl;
    }
    if (config.signOutUrl) {
      this.signOutUrl = config.signOutUrl;
    }
    if (config.layout) {
      this.layout = config.layout;
    }
  }
}

export const HNG_APP_CONFIG = new InjectionToken<HngAppConfig>('AppConfig', {
  providedIn: 'root',
  factory: () => {
    return new HngAppConfig({});
  },
});
